/**
 * Toggle function for preview content sections.
 * Toggles visibility of content and updates icon state.
 *
 * @param {string} contentId - ID of the content element to toggle
 * @param {string} iconSelector - CSS selector for the icon element to update
 */
export function togglePreviewContent(contentId, iconSelector) {
    const content = document.getElementById(contentId);
    const icon = document.querySelector(iconSelector);
    
    if (!content || !icon) {
        return;
    }
    
    if (content.style.display === 'none') {
        content.style.display = 'block';
        icon.textContent = '▲';
    } else {
        content.style.display = 'none';
        icon.textContent = '▼';
    }
}

/**
 * Global toggle function for achievements preview.
 * Used in HTML templates via onclick attribute.
 */
window.toggleAchievementsPreview = function() {
    togglePreviewContent('achievementsPreviewContent', '.achievements-preview-toggle-icon');
};

/**
 * Global toggle function for intro topics preview.
 * Used in HTML templates via onclick attribute.
 */
window.toggleIntroTopicsPreview = function() {
    togglePreviewContent('introTopicsPreviewContent', '.intro-topics-preview-toggle-icon');
};

/**
 * Global toggle function for feedback form.
 * Used in HTML templates via onclick attribute.
 */
window.toggleFeedbackForm = function() {
    const content = document.getElementById('feedbackFormContent');
    const icon = document.querySelector('.feedback-form-toggle-icon');
    
    if (!content || !icon) {
        return;
    }
    
    if (content.style.display === 'none') {
        content.style.display = 'block';
        icon.textContent = '▲';
    } else {
        content.style.display = 'none';
        icon.textContent = '▼';
    }
};

